import {ref} from 'vue';

export function useDepositResult() {
    const calculatedDeposits = ref([]);
    const isScrollAllow = ref(false);

    function onShowFoundDepositsHandler(deposits, scrollAllow) {
        calculatedDeposits.value = deposits;
        isScrollAllow.value = scrollAllow;
    }

    return {
        calculatedDeposits,
        isScrollAllow,
        onShowFoundDepositsHandler,
    };
};
